class VideoList {
  constructor() {
    this.init();
  }

  init() {
    const items = document.querySelectorAll<HTMLElement>('.video__item');

    items.forEach(item => {
      const button = item.querySelector<HTMLButtonElement>('.video__item-play');
      const player = item.querySelector<HTMLElement>('.video__item-player');
      const iframe = item.querySelector<HTMLIFrameElement>('.video__item-iframe');

      if (!button || !player || !iframe) return;

      button.addEventListener('click', () => {
        const url = button.dataset.youtube;
        if (!url) return;

        const id = this.getYoutubeId(url);
        if (!id) return;

        iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1`;
        player.hidden = false;
        button.hidden = true;
      });
    });
  }

  getYoutubeId(url: string): string | null {
    const m = url.match(/(?:v=|\/)([0-9A-Za-z_-]{11})/);
    return m ? m[1] : null;
  }
}

export const videoList = new VideoList();
